import React from 'react';
import Form from '../../components/pages/CreateAccount/Form/Form';

const CreateAccount = () => {
  return (
    <div>
      <Form />
    </div>
  );
};

export default CreateAccount;
